export function formatDateTime(value: string | null, empty = "нет данных") {
  if (!value) return empty;
  return new Intl.DateTimeFormat("ru-RU", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
}

export function formatTokens(value: number) {
  return new Intl.NumberFormat("ru-RU").format(value);
}

export function formatUsd(value: number | null) {
  if (value === null) return "нет данных";
  const digits = value > 0 && value < 0.01 ? 6 : 4;
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: digits,
    maximumFractionDigits: 6,
  }).format(value);
}

export function formatRubTotal(value: string): string {
  return `${new Intl.NumberFormat("ru-RU").format(BigInt(value))} ₽`;
}

export function formatMoscowDateTime(value: string | null): string {
  if (value === null) return "не ограничен";
  return new Intl.DateTimeFormat("ru-RU", {
    timeZone: "Europe/Moscow",
    dateStyle: "short",
    timeStyle: "long",
  }).format(new Date(value));
}

export function localDateTimeToIso(value: string): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value);
  if (!match) return null;
  const [year, month, day, hour, minute] = match.slice(1).map(Number);
  if (
    year === undefined ||
    month === undefined ||
    day === undefined ||
    hour === undefined ||
    minute === undefined
  )
    return null;
  const date = new Date(year, month - 1, day, hour, minute, 0, 0);
  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day ||
    date.getHours() !== hour ||
    date.getMinutes() !== minute
  )
    return null;
  return date.toISOString();
}

/** Decimal string transport: never round a recorded bank amount through a float. */
export function formatPaymentRub(value: string): string {
  if (!/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(value))
    return "Некорректная сумма";
  const [whole = "0", fraction = ""] = value.split(".");
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, " ")},${fraction.padEnd(2, "0")} ₽`;
}

export function moscowDateTimeToIso(value: string): string | null {
  if (
    !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?$/.test(value) ||
    value.startsWith("0000")
  )
    return null;
  const parts = value.split("T");
  const clock = parts[1]!;
  const normalized = `${parts[0]}T${clock.length === 5 ? clock + ":00" : clock}`;
  const date = new Date(`${normalized}+03:00`);
  if (!Number.isFinite(date.getTime())) return null;
  const back = new Date(date.getTime() + 3 * 60 * 60 * 1000).toISOString();
  const expected = normalized.includes(".")
    ? normalized.split(".")[0] + "." + normalized.split(".")[1]!.padEnd(3, "0")
    : normalized + ".000";
  return back === expected + "Z" ? date.toISOString() : null;
}

export function isoToMoscowInput(value: string): string {
  return new Date(Date.parse(value) + 3 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, -1);
}

/** Invoice expiresAt is exclusive; Moscow midnight means the preceding calendar day is included. */
export function formatInvoicePaymentDeadline(expiresAt: string): string {
  const date = new Date(Date.parse(expiresAt) - 1);
  return `по ${new Intl.DateTimeFormat("ru-RU", { timeZone: "Europe/Moscow", dateStyle: "short" }).format(date)} включительно`;
}
